import { useEffect } from "react";
import ReactGA from "react-ga4";
import { ga4MeasurementID, ga4DebugMode } from "../global";

const GA_DEBUG_MODE: boolean = parseInt(ga4DebugMode) === 1;

export const useAnalytics = () => {
    useEffect(() => {
        if (ga4MeasurementID) {
            ReactGA.initialize(ga4MeasurementID);
            console.log(`GA4 initialized with ID: ${ga4MeasurementID}, debug: ${GA_DEBUG_MODE}`);
        } else {
            console.warn('GA_MEASUREMENT_ID is not defined');
        }
    }, []);

    const trackEvent = (
        eventName: string,
        params: {
            category: string;
            label?: string;
            value?: number;
            user_id?: string;
            registry_id?: string;
            [key: string]: any;
        }
    ) => {
        if (!ga4MeasurementID) return;

        const eventParams = {
            ...params,
            ...(GA_DEBUG_MODE ? { debug_mode: true } : {}),
        };

        ReactGA.event(eventName, eventParams);

        if (GA_DEBUG_MODE) {
            console.log('[GA4 DEBUG] Tracked event:', eventName, eventParams);
        }
    };

    return { trackEvent };
};
